/* Recover failed catalog cutouts without retry loops or losing the product photo. */
(function () {
  const cdnPrefix = '/s/files/1/0777/1373/5979/';
  function canonicalSource(value, base) {
    try {
      const source = new URL(value, base);
      if (source.protocol !== 'https:' || source.username || source.password || source.port) return null;
      const storeHost = ['deluludesigns.com', 'www.deluludesigns.com', 'girlstore111111.myshopify.com'].includes(source.hostname)
        || /^[a-z0-9-]+-77713735979\.shopifypreview\.com$/.test(source.hostname);
      let path;
      if (source.hostname === 'cdn.shopify.com' && source.pathname.startsWith(cdnPrefix)) {
        path = source.pathname.slice(cdnPrefix.length);
      } else if (storeHost && source.pathname.startsWith('/cdn/shop/')) {
        path = source.pathname.slice('/cdn/shop/'.length);
      } else return null;
      if (!/^(files|products)\/[^/\\]+\.(png|jpe?g|webp|avif|gif)$/i.test(decodeURIComponent(path))) return null;
      const result = new URL('https://cdn.shopify.com' + cdnPrefix + path);
      for (const key of ['v', 'width']) {
        if (/^\d{1,20}$/.test(source.searchParams.get(key) || '')) result.searchParams.set(key, source.searchParams.get(key));
      }
      return result.href;
    } catch (_) { return null; }
  }
  function originalSource(value, base, service) {
    try {
      const processed = new URL(value, base);
      if (processed.origin !== new URL(service).origin || processed.pathname !== '/image') return null;
      return canonicalSource(processed.searchParams.get('src'), base);
    } catch (_) { return null; }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { canonicalSource, originalSource };
  if (typeof document === 'undefined') return;
  const service = document.currentScript?.dataset.cutoutService;
  const attempts = new WeakMap();
  function recover(image) {
    if (!image || image.tagName !== 'IMG') return;
    const current = image.currentSrc || image.getAttribute('src');
    const original = originalSource(current, document.baseURI, service)
      || canonicalSource(image.dataset.originalSrc || current, document.baseURI);
    if (!original) return;
    let tried = attempts.get(image);
    if (!tried) { tried = new Set(); attempts.set(image, tried); }
    // Remove responsive candidates too, so Safari cannot keep selecting the failed file.
    const smaller = new URL(original);
    smaller.searchParams.set('width', '400');
    const next = [original, smaller.href].find(url => url !== current && !tried.has(url));
    if (!next) return;
    tried.add(next);
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.setAttribute('data_max_resolution', next);
    image.src = next;
  }
  function inspect(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    const images = root.tagName === 'IMG' ? [root] : root.querySelectorAll('img');
    for (const image of images) {
      if (image.complete && image.naturalWidth === 0 && image.getAttribute('src')) recover(image);
    }
  }
  document.addEventListener('error', event => recover(event.target), true);
  inspect(document);
  // Section-rendered cart/filter content may have failed before joining the document.
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) inspect(node);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
